'use client';
import { factory, Flex, AspectRatioKeeper, PhotoOverlay, Typography, DsmColor, omitText, ImageAction, Image } from '@kohler-dsm-library/kohler-core';
import { PlusIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState } from 'react';
import { FeatureModal } from '../FeatureModal/FeatureModal.mjs';
import classes from './FeatureCard.module.css.mjs';

const FeatureCard = factory((props, ref) => {
  const { heading, modalContent, image, imageActionCTA, className, ...rest } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const handleClick = () => {
    if (modalContent) {
      setModalOpen(true);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      className: clsx(classes.featureCardContainer, className, "kohler-feature-card-root"),
      component: "div",
      height: "100%",
      ref,
      ...rest
    },
    /* @__PURE__ */ React.createElement(AspectRatioKeeper, { aspectRatio: "10:16" }, /* @__PURE__ */ React.createElement(PhotoOverlay, { className: classes.featureCardOverlay, opacity: 30, direction: "bottom-top" }, /* @__PURE__ */ React.createElement(Flex, { justify: "space-between", gap: 10, align: "center", className: classes.featureCardContentContainer }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: heading.component || "h3",
        ...omitText(heading),
        size: "label-regular-l",
        textColor: DsmColor.ContentOnPhoto
      },
      heading.text
    ), (imageActionCTA || modalContent) && /* @__PURE__ */ React.createElement(
      ImageAction,
      {
        component: "button",
        type: "button",
        icon: PlusIcon,
        "aria-label": "Expand feature card and open modal",
        ...imageActionCTA,
        onClick: (e) => {
          imageActionCTA?.onClick?.(e);
          handleClick();
        }
      }
    ))), /* @__PURE__ */ React.createElement(Image, { ...image })),
    modalOpen && modalContent && /* @__PURE__ */ React.createElement(
      FeatureModal,
      {
        portalProps: { target: ".kohler-feature-cards-with-modal-slider-root" },
        withinPortal: true,
        opened: modalOpen,
        ...modalContent,
        onClose: () => {
          modalContent.onModalClose?.();
          setModalOpen(false);
        }
      }
    )
  );
});

export { FeatureCard };
